<template>
  <b-modal
    id="modal-viewer"
    ref="modalConfigurationViewer"
    :title="$t('viewer.tooltips.configuration')"
    hide-footer
    centered
    modal-class="modal-configuration-viewer"
    static
    size="sm"
  >
    <div>
      <b-container>
        <b-row>
          <b-col cols="9">
            {{ $t('viewer.modal.automaticAnnotationsWindow') }}
          </b-col>
          <b-col
            cols="3"
            class="d-flex justify-content-end"
          >
            <div class="d-flex">
              <div class="col-3 switch-btn p-0">
                <input
                  id="show_annotations_modal"
                  type="checkbox"
                  class="offscreen"
                  :checked="configuration.showAnnotationWindow"
                  aria-hidden="true"
                  @change="toogleShowAnnotationWindow()"
                >
                <label
                  for="show_annotations_modal"
                  class="switch mb-0"
                />
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="9">
            {{ $t('viewer.modal.showAnnotations') }}
          </b-col>
          <b-col
            cols="3"
            class="d-flex justify-content-end"
          >
            <div class="d-flex">
              <div class="col-3 switch-btn p-0">
                <input
                  id="show_annotations"
                  type="checkbox"
                  class="offscreen"
                  :checked="configuration.showAnnotations"
                  aria-hidden="true"
                  @change="toogleShowAnnotations()"
                >
                <label
                  for="show_annotations"
                  class="switch mb-0"
                />
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div>
              {{ $t('viewer.modal.annotationDefaultColor') }}
            </div>
            <div class="color-row d-flex mt-2">
              <b-button
                :class="{'active-color': configuration.defaultColor === 'rgb(0, 0, 0)'}"
                style="background: rgb(0, 0, 0) !important;"
                class="color-btn modal-color-btn ml-1"
                @click="changeColor('rgb(0, 0, 0)')"
              />
              <b-button
                :class="{'active-color': configuration.defaultColor === 'rgb(255, 255, 255)'}"
                style="background: rgb(255, 255, 255) !important;"
                class="color-btn modal-color-btn ml-1"
                @click="changeColor('rgb(255, 255, 255)')"
              />
              <b-button
                :class="{'active-color': configuration.defaultColor === 'rgb(77, 77, 218)'}"
                style="background: rgb(77, 77, 218) !important;"
                class="color-btn modal-color-btn ml-1"
                @click="changeColor('rgb(77, 77, 218)')"
              />
              <b-button
                :class="{'active-color': configuration.defaultColor === 'rgb(83, 255, 106)'}"
                style="background: rgb(83, 255, 106) !important;"
                class="color-btn modal-color-btn ml-1"
                @click="changeColor('rgb(83, 255, 106)')"
              />
              <b-button
                :class="{'active-color': configuration.defaultColor === 'rgb(244, 255, 83)'}"
                style="background: rgb(244, 255, 83) !important;"
                class="color-btn modal-color-btn ml-1"
                @click="changeColor('rgb(244, 255, 83)')"
              />
              <b-button
                :class="{'active-color': configuration.defaultColor === 'rgb(240, 40, 13)'}"
                style="background: rgb(240, 40, 13) !important;"
                class="color-btn modal-color-btn ml-1"
                @click="changeColor('rgb(240, 40, 13)')"
              />
            </div>
          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="9">
            {{ $t('viewer.modal.showScale') }}
          </b-col>
          <b-col
            cols="3"
            class="d-flex justify-content-end"
          >
            <div class="d-flex">
              <div class="col-3 switch-btn p-0">
                <input
                  id="show_scale"
                  type="checkbox"
                  class="offscreen"
                  :checked="configuration.showScale"
                  aria-hidden="true"
                  @change="toogleShowScale()"
                >
                <label
                  for="show_scale"
                  class="switch mb-0"
                />
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="9">
            {{ $t('viewer.modal.showPictureTitle') }}
          </b-col>
          <b-col
            cols="3"
            class="d-flex justify-content-end"
          >
            <div class="d-flex">
              <div class="col-3 switch-btn p-0">
                <input
                  id="show_title"
                  type="checkbox"
                  class="offscreen"
                  :checked="configuration.showTitle"
                  aria-hidden="true"
                  @change="toogleShowTitle()"
                >
                <label
                  for="show_title"
                  class="switch mb-0"
                />
              </div>
            </div>
          </b-col>
        </b-row>
        <!-- TODO: Hidden from UI until development -->
        <!--<b-row>
                    <b-col cols="9">{{ $t('viewer.modal.userActivityOnMap') }}</b-col>
                    <b-col cols="3" class="d-flex justify-content-end flex-column align-items-end">
                        <div class="d-flex">
                            <div class="col-3 switch-btn p-0">
                                <input type="checkbox" id="show_tracking" class="offscreen" aria-hidden="true"/>
                                <label for="show_tracking" class="switch mb-0"></label>
                            </div>
                        </div>
                        <div class="mt-2">
                            <b-button
                                size="sm"
                                variant="outline-secondary"
                            >{{ $t('viewer.modal.reset') }}</b-button>
                        </div>
                    </b-col>
                    <b-col cols="12"><hr></b-col>
                </b-row>
                <b-row>
                    <b-col cols="9">{{ $t('viewer.modal.openViewerOnSecondMonitor') }}</b-col>
                    <b-col cols="3" class="d-flex justify-content-end">
                        <div class="d-flex">
                            <div class="col-3 switch-btn p-0">
                                <input type="checkbox" id="show_alt_monitor" class="offscreen" aria-hidden="true"/>
                                <label for="show_alt_monitor" class="switch mb-0"></label>
                            </div>
                        </div>
                    </b-col>
                </b-row>-->
      </b-container>
    </div>
  </b-modal>
</template>

<script>
export default {
    name: 'ModalConfigurationViewer',
    props: {
        configuration: { type: Object, required: true }
    },
    methods: {
        show() {
            this.$refs.modalConfigurationViewer.show()
        },
        hide() {
            this.$refs.modalConfigurationViewer.hide()
        },
        changeColor(color) {
            this.$emit('configurationChange', ['defaultColor', color])
        },
        toogleShowAnnotations() {
            this.$emit('configurationChange', ['showAnnotations', !this.configuration.showAnnotations])
        },
        toogleShowTitle() {
            this.$emit('configurationChange', ['showTitle', !this.configuration.showTitle])
        },
        toogleShowScale() {
            this.$emit('configurationChange', ['showScale', !this.configuration.showScale])
        },
        toogleShowAnnotationWindow() {
            this.$emit('configurationChange', ['showAnnotationWindow', !this.configuration.showAnnotationWindow])
        }
    }
}
</script>

<style lang="scss">
    .modal-configuration-viewer .modal-dialog {
        color: #FFF;
    }
    .modal-configuration-viewer .form-label {
        color: vt-color(white-light, .5);
    }
    .modal-configuration-viewer .color-row .btn {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        margin-right: 10px !important;
        border: none;
    }
    .modal-configuration-viewer .color-row .btn:hover {
        box-shadow: 0px 0px 3px 3px #9c9c9c;
    }
    .modal-configuration-viewer .color-row .btn.active-color {
        box-shadow: 0px 0px 3px 3px #9c9c9c !important;
    }
</style>

<style lang="scss" scoped>
    .offscreen {
        position: absolute;
        left: -9999px;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 20px;
        background-color: rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        transition: all 0.3s;
    }

    .switch::after {
        content: '';
        position: absolute;
        width: 18px;
        height: 18px;
        border-radius: 18px;
        background-color: white;
        top: 1px;
        left: 1px;
        transition: all 0.3s;
    }

    input[type='checkbox']:checked + .switch::after {
        transform: translateX(20px);
    }

    input[type='checkbox']:checked + .switch {
        background-color: vt-color(primary);
    }

    .modal-color-btn {
        height: 20px;
        width: 20px;
    }
</style>
